
import { Component, Vue } from 'vue-property-decorator'
import ticketLive from '@/views/Ticket/indexLive.vue'

@Component({
  name: 'AllMyOrderLists',
  components: {
    ticketLive
  }
})
export default class extends Vue {
}
